/* eslint-disable react/prop-types */
import { RaImage, RaTypography } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'

import styles from './ra-accommodation-grid.module.scss'

export const RaAccommodationGalleryModal = ({ gallery }) => {
  return (
    <div className={styles['ra-accommodation-gallery-modal']}>
      {Loop(gallery, (image, i) => (
        <div key={i}>
          <RaImage image={image} />
          <div>
            {image.caption && <RaTypography fontFamily="heading">{image.caption}</RaTypography>}
          </div>
        </div>
      ))}
    </div>
  )
}
